import useFreshChat from '@src/hooks/useFreshChat';

const REACT_APP_FRESHDESK_TOKEN = process.env
  .REACT_APP_FRESHDESK_TOKEN as string;

export default function FreshChat() {
  useFreshChat(REACT_APP_FRESHDESK_TOKEN);
  return null;
}
